import type { QueryClient } from '@tanstack/react-query'

import {
  getListShipmentsApiV1ShipmentsGetQueryKey,
  getShipmentCountsApiV1ShipmentsCountsGetQueryKey,
  getShipmentStatusCountsApiV1ShipmentsCountsStatusesGetQueryKey,
} from '#/shared/api/generated/shipment/theCargoShipment'

export function invalidateShipmentLists(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({
    queryKey: getListShipmentsApiV1ShipmentsGetQueryKey(),
  })
  // Stage counts back the quotes/orders sidebar badges…
  void queryClient.invalidateQueries({
    queryKey: getShipmentCountsApiV1ShipmentsCountsGetQueryKey(),
  })
  // …and status counts back the leads sidebar badge + every header per-tab
  // count. They're a distinct endpoint (`/counts/statuses`), so partial-matching
  // on the keys above never reaches them — invalidate it explicitly.
  void queryClient.invalidateQueries({
    queryKey: getShipmentStatusCountsApiV1ShipmentsCountsStatusesGetQueryKey(),
  })
}
